import React from 'react';
import { HierarchyFolder, TileInfo } from 'app/home/index.functions';
import { UserAuth } from 'store/auth';
import { alpha, Box, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import { Tile4FavoriteData } from 'app/home/index';
import useBundleTranslation from 'i18n';
import { TileFavoriteIcon, TileFavoriteIconInfo } from 'app/home/tile/components/TileFavoriteIcon';
import { useHomeContext } from 'app/home/context';

const NamesToDisplay = 2;

export const TileFavorite = function ({
    style,
    defaultStyle,
    tile,
    tileicons,
    userauth,
    setTile4Favorite,
    favorites,
}: {
    style?: any;
    defaultStyle?: any;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
    userauth: UserAuth;
    setTile4Favorite: (data: Tile4FavoriteData | null) => void;
    favorites: HierarchyFolder[];
}) {
    const { t } = useBundleTranslation('app/favorites');
    const ctx = useHomeContext();
    const [isEmbedded] = [ctx.isEmbedded];

    if (undefined === defaultStyle) {
        defaultStyle = {
            position: 'absolute',
            top: '4px',
            left: '10px',
        };
    }

    const favoriteIcon = tile.is_in_favorites ? 'favorite-solid' : 'favorite';

    const elementId = tile.element_id ?? 0;
    const segmentValueId = tile.segment_value_id ?? 0;
    const favoritesIds = tile.in_favorites ? tile.in_favorites.split(',') : [];

    const onFavoriteClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        event.preventDefault();

        setTile4Favorite({
            elementId,
            segmentValueId,
            elementName: tile.element_dashboard_name ?? '',
        });
    };

    const favoritesCount = favoritesIds.length;

    const favoritesList =
        favoritesIds
            .slice(0, NamesToDisplay)
            .map((id) => favorites.find((favorite) => favorite.favorite_id === parseInt(id))?.name)
            .join(', ') + (favoritesCount > NamesToDisplay ? ', ...' : '');

    const tooltip = t('addFavorites', { count: favoritesCount, list: favoritesList, entity: tile.element_type });

    if (isEmbedded || tile.has_access == 'N') return null;

    return (
        <TileFavoriteIcon
            tile={tile as TileFavoriteIconInfo}
            setTile4Favorite={setTile4Favorite}
            favorites={favorites}
            defaultStyle={defaultStyle}
        />
    );
};
